import { MetaPathwayAction_Types_WithProtocols, MetaPathwayAction_Types_WithoutProtocols } from './types.js';
import { ImplementationMissingException } from '@nu-art/ts-common';
export const isMetaPathwayAction_WithProtocol = (instance) => {
    return [...MetaPathwayAction_Types_WithProtocols].includes(instance?.type);
};
export const isMetaPathwayAction_WithoutProtocol = (instance) => {
    return [...MetaPathwayAction_Types_WithoutProtocols].includes(instance?.type);
};
export const getCleanMetaPathwayAction = (type) => {
    if ([...MetaPathwayAction_Types_WithProtocols].includes(type))
        return {
            type: type,
            protocolIds: [],
        };
    if ([...MetaPathwayAction_Types_WithoutProtocols].includes(type))
        return {
            type: type,
        };
    throw new ImplementationMissingException(`No implementation for MetaPathwayAction type ${type}`);
};
//# sourceMappingURL=utils.js.map